/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: ${({ isFullWidth }) => (isFullWidth ? 'flex' : 'inline-flex')};
  gap: 8px;
  width: ${({ isFullWidth }) => (isFullWidth ? '100%' : 'unset')};
  height: fit-content;
  align-items: center;
  padding: 7px 0 7px 7px;
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  background-color: white;
  max-width: ${({ isIcon, isFullWidth }) =>
    !isIcon && !isFullWidth ? '194px' : isIcon && !isFullWidth ? '250px' : 'unset'};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ isIcon }) => (isIcon ? 'calc(100% - 96px)' : 'calc(100% - 40px)')};
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._900};
`;

export const Description = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
`;

const Subtitle = styled.div`
  font-size: 12px;
  line-height: 16px;
  display: block;
`;

export const DescrTitle = styled(Subtitle)`
  color: ${Palette.PrimaryGray._500};
  flex-shrink: 0;
  max-width: 100%;
`;

export const DescrSubTitle = styled(Subtitle)`
  color: ${Palette.PrimaryGray._700};
  width: ${({ titleWidth }) => (titleWidth ? `calc(100% - ${titleWidth}px - 4px)` : '100%')};
`;

export const Image = styled.div`
  flex-shrink: 0;
  border-radius: 4px;
  display: flex;
  overflow: hidden;
  margin-right: 8px;
`;
